import { Heading, Text } from '@chakra-ui/react'
// import ChakraUIRenderer from 'chakra-ui-markdown-renderer'

export default {
  //   ...ChakraUIRenderer(),
  // biome-ignore lint/suspicious/noExplicitAny: props
  h1(props: any) {
    return (
      <Heading as="h1" size="4xl" mb={8}>
        {props.children}
      </Heading>
    )
  },
  // biome-ignore lint/suspicious/noExplicitAny: props
  h2(props: any) {
    return (
      <Heading as="h2" size="3xl" mt={12} mb={4}>
        {props.children}
      </Heading>
    )
  },
  // biome-ignore lint/suspicious/noExplicitAny: props
  h3(props: any) {
    return (
      <Heading as="h3" size="2xl" mt={10} mb={4}>
        {props.children}
      </Heading>
    )
  },
  // biome-ignore lint/suspicious/noExplicitAny: props
  h4(props: any) {
    return (
      <Heading as="h4" size="xl" mt={6} mb={2}>
        {props.children}
      </Heading>
    )
  },
  // biome-ignore lint/suspicious/noExplicitAny: props
  li(props: any) {
    return <li style={{ marginTop: 8 }}>{props.children}</li>
  },
  // biome-ignore lint/suspicious/noExplicitAny: props
  hr(_props: any) {
    return <hr />
  },
  // biome-ignore lint/suspicious/noExplicitAny: props
  p(props: any) {
    return (
      <Text as="p" color="text.text-base" fontSize="md" lineHeight="1.5rem">
        {props.children}
      </Text>
    )
  },
}
